import {
  CLEAR_TEST_INFO,
  END_TEST_TIMER,
  GET_TEST_BY_COURSE,
  GET_TEST_BY_COURSE_ERROR,
  GET_TEST_BY_COURSE_LOADING,
  GET_TEST_BY_COURSE_SUCCESS,
  GET_TEST_QUESTIONS,
  GET_TEST_QUESTIONS_ERROR,
  GET_TEST_QUESTIONS_LOADING,
  GET_TEST_QUESTIONS_SUCCESS,
  GET_TEST_RESULT,
  GET_TEST_RESULT_CLEAR,
  GET_TEST_RESULT_ERROR,
  GET_TEST_RESULT_LOADING,
  GET_TEST_RESULT_SUCCESS,
  INSERT_TEST_DATA,
  INSERT_TEST_DATA_ERROR,
  INSERT_TEST_DATA_LOADING,
  INSERT_TEST_DATA_SUCCESS,
  QUESTION_SAVE_AND_NEXT,
  QUESTION_SAVE_AND_NEXT_EVAL,
  SET_TEST_INFO,
  START_TEST_TIMER,
} from "./constants";

const testInfo = { data: [], loading: false, success: false, error: "" };
const testResult = { data: null, loading: false, success: false, error: "" };
const testDetails = { data: null };
const testQuestions = { data: [], loading: false, success: false, error: "" };
const testTime = { data: 0, success: false };
const insertTest = { data: null, loading: false, success: false, error: "" };
const questionSummary = {
  totalQuestion: 0,
  current: 0,
  index: 1,
  questionsInfo: [],
};
const submitAnswer = [];
const testInfoPtr = {};

const initialState = {
  testInfo: { ...testInfo },
  testResult: { ...testResult },
  testDetails: { ...testDetails },
  testQuestions: { ...testQuestions },
  testTime: { ...testTime },
  questionSummary: { ...questionSummary },
  insertTest: { ...insertTest },
  submitAnswer: [...submitAnswer],
  testInfoPtr: { ...testInfoPtr },
};

const testReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TEST_BY_COURSE:
      return {
        ...state,
        testInfo: {
          loading: false,
          success: payload?.isNew ? false : false,
          error: "",
          data: payload?.isNew ? [] : state.testInfo?.data,
        },
      };
    case GET_TEST_BY_COURSE_LOADING:
      return { ...state, testInfo: { ...state.testInfo, loading: true } };
    case GET_TEST_BY_COURSE_SUCCESS:
      return {
        ...state,
        testInfo: {
          ...state.testInfo,
          loading: false,
          success: true,
          data: payload?.isMerge
            ? [...state.testInfo.data, ...payload?.resultTest]
            : payload?.resultTest,
        },
      };
    case GET_TEST_BY_COURSE_ERROR:
      return {
        ...state,
        testInfo: { ...state.testInfo, loading: false, error: payload },
      };
    case GET_TEST_RESULT:
      return { ...state, ...testResult };
    case GET_TEST_RESULT_LOADING:
      return { ...state, testResult: { ...testResult, loading: true } };
    case GET_TEST_RESULT_SUCCESS:
      return {
        ...state,
        testResult: { ...testResult, success: true, data: payload },
      };
    case GET_TEST_RESULT_ERROR:
      return {
        ...state,
        testResult: { ...testResult, error: payload },
      };
    case GET_TEST_RESULT_CLEAR:
      return {
        ...state,
        testResult: { ...testResult },
      };
    case SET_TEST_INFO:
      return { ...state, testDetails: { data: payload } };
    case CLEAR_TEST_INFO:
      return { ...state, testDetails: { ...testDetails } };
    case GET_TEST_QUESTIONS:
      return { ...state, ...testQuestions, ...submitAnswer };
    case GET_TEST_QUESTIONS_LOADING:
      return { ...state, testQuestions: { ...testQuestions, loading: true } };
    case GET_TEST_QUESTIONS_SUCCESS:
      return {
        ...state,
        testQuestions: {
          ...testQuestions,
          success: true,
          data: payload?.map((x, i) => ({ ...x, count: i + 1 })),
        },

        questionSummary: {
          ...questionSummary,
          totalQuestion: payload?.length || 0,
          questionsInfo: payload?.map((x, index) =>
            index === 0
              ? {
                  status: "notAnswered",
                  submittedAns: null,
                  id: x?.TestQuestionsPtr?.objectId,
                  index: index,
                  marks: x?.TestQuestionsPtr?.Marks,
                  negativeMarks: x?.TestQuestionsPtr?.NegativeMarks,
                  correctAns: +x?.TestQuestionsPtr?.CorrectAnswer?.[0],
                }
              : {
                  status: "",
                  submittedAns: null,
                  id: x?.TestQuestionsPtr?.objectId,
                  index: index,
                  marks: x?.TestQuestionsPtr?.Marks,
                  negativeMarks: x?.TestQuestionsPtr?.NegativeMarks,
                  correctAns: +x?.TestQuestionsPtr?.CorrectAnswer?.[0],
                }
          ),
        },
        submitAnswer: payload?.map((x) => null),
        testInfoPtr: payload?.[0].TestInfoPtr,
      };
    case GET_TEST_QUESTIONS_ERROR:
      return { ...state, testQuestions: { ...testQuestions, error: payload } };
    case START_TEST_TIMER:
      return {
        ...state,
        testTime: { data: payload * 60, success: true, endExam: false },
      };
    case END_TEST_TIMER:
      return {
        ...state,
        testTime: { data: payload, success: false, endExam: true },
      };
    case QUESTION_SAVE_AND_NEXT:
      return {
        ...state,
        questionSummary: {
          ...state.questionSummary,
          questionsInfo: payload?.questionsInfo,
          current: payload?.current,
          index: payload?.index,
        },
      };
    case QUESTION_SAVE_AND_NEXT_EVAL:
      return {
        ...state,
        questionSummary: {
          ...state.questionSummary,
          questionsInfo: payload?.questionsInfo,
          current: payload?.current,
          index: payload?.index,
        },
        submitAnswer: payload?.arr,
      };
    case INSERT_TEST_DATA:
      return { ...state, ...insertTest };
    case INSERT_TEST_DATA_LOADING:
      return { ...state, insertTest: { ...insertTest, loading: true } };
    case INSERT_TEST_DATA_SUCCESS:
      return {
        ...state,
        insertTest: { ...insertTest, data: payload, success: true },
      };
    case INSERT_TEST_DATA_ERROR:
      return { ...state, insertTest: { ...insertTest, error: payload } };
    default:
      return { ...state };
  }
};

export default testReducer;
